module.exports = __webpack_public_path__ + "img/strategy_bb_purple.9ea424f8.png";